<template>
<div style="width:100%;padding-top: 60px">
  <div style="position: fixed;top: 0px;z-index: 999;width: 100%; background-color:#fff;">
    <div style="text-align:center">
      <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">办理</van-button>
      <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
    </div>
    <div class="doTask" v-if="isshow">
      <div>
        <van-field name="radio" label="审批意见">
          <template #input>
            <van-radio-group v-model="auditForm.status" direction="horizontal">
              <van-radio name="同意">同意</van-radio>
              <van-radio name="不同意">不同意</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </div>
      <div>
        <van-cell-group>
          <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea" placeholder="请输入审批说明" />
        </van-cell-group>
      </div>
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
      </div>
    </div>
  </div>

  <van-collapse v-model="activeNames">
    <van-field v-model="inputForm.applyCode" label="开立账户申请单编号" label-width="140px" readonly input-align="left" :border="false" />
    <van-field v-model="inputForm.companyName" label="公司名称" label-width="140px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
    <van-field v-model="inputForm.operatorName" label="经办人" label-width="140px" readonly input-align="left" :border="false" />
    <van-field v-model="inputForm.bankName" label="开户银行名称" label-width="140px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
    <van-field v-model="inputForm.bankAccount" label="银行账号" label-width="140px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
    <van-field v-model="inputForm.accountTypeLabel" label="账户性质" label-width="140px" readonly input-align="left" :border="false" />
    <van-field v-model="inputForm.legalSeal" label="预留法人印鉴章" label-width="140px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
    <van-field v-model="inputForm.fixedDeductItem" label="固定扣款项目" label-width="140px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
    <van-field v-model="inputForm.onlineBankFlagLabel" label="网银开通" label-width="140px" readonly input-align="left" :border="false" />
    <van-field v-model="inputForm.onlineMaker" label="网银盾制单人" label-width="140px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
    <van-field v-model="inputForm.onlineChecker" label="网银盾审核人" label-width="140px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
    <van-field v-model="inputForm.onlineQuota" label="网银额度" label-width="140px" readonly input-align="left" :border="false" />
    <van-field v-model="inputForm.businessScope" label="经营范围" label-width="140px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
    <van-field v-model="inputForm.address" label="地址" label-width="140px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
    <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.smsList && inputForm.smsList.length > 0">
      <p style="color: #AAA">短信通知信息</p>
      <p style="display: block;" v-for="(row, index) in inputForm.smsList" :key="index">
        姓名：{{ row.name || '-' }}　手机号：{{ row.mobile || '-' }}
      </p>
    </div>
    <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.shareholderList && inputForm.shareholderList.length > 0">
      <p style="color: #AAA">股东信息</p>
      <p style="display: block;" v-for="(row, index) in inputForm.shareholderList" :key="index">
        姓名：{{ row.name || '-' }}　身份证号：{{ row.idCard || '-' }}　手机号：{{ row.mobile || '-' }}
      </p>
    </div>
  </van-collapse>
  <process-record :procInsId="procInsId"></process-record>
</div>
</template>

<script>
import processRecord from "@/components/processRecord/processRecord.vue";
import TaskService from "@/api/flowable/TaskService";
import ProcessService from "@/api/flowable/ProcessService";
import QueryInfoService from "@/api/system/queryInfoService";

export default {
  name: "FundsAccountOpenInfo",
  data(){
    return {
      activeNames: ["1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16"],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type:'',
      inputForm:{
        isDoTask: false,
        isLastTask: false,
        applyCode: '',
        companyName: '',
        operatorName: '',
        bankName: '',
        bankAccount: '',
        accountType: '',
        accountTypeLabel: '',
        legalSeal: '',
        fixedDeductItem: '',
        onlineBankFlag: '',
        onlineBankFlagLabel: '',
        onlineMaker: '',
        onlineChecker: '',
        onlineQuota: '',
        businessScope: '',
        address: '',
        smsList: [],
        shareholderList: []
      },
      formKey: '/funds/accountInfo/FundsAccountOpenInfoFlowForm',
      flowTable: 'funds_account_open_info'
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
    if(!window.matchMedia("(orientation:portrait)").matches){
      dd.device.screen.resetView({
        onSuccess : function(result) {},
        onFail : function(err) {}
      });
    }
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById(id, '/funds/fundsAccountOpenInfo/queryById').then(({ data }) => {
        this.inputForm = data
        // 子表兜底成数组，模板里直接取 .length
        this.inputForm.smsList = data.smsList || []
        this.inputForm.shareholderList = data.shareholderList || []
        this.getDict([
          ['funds_account_type', 'accountType'],
          ['yes_no', 'onlineBankFlag']
        ])
      }).catch(e => {
        console.log(e)
      })
    },
    // 字典翻译：移动端未挂载 $dictUtils，统一走 getDictMap
    getDict(dicts) {
      dicts.map(([dictType, formField]) => {
        new QueryInfoService().getDictMap().then(({ data }) => {
          const list = (data && data[dictType]) ? data[dictType] : []
          const hit = list.find(item => String(item.value) === String(this.inputForm[formField]))
          this.$set(this.inputForm, `${formField}Label`, hit ? hit.label : '')
        }).catch(e => {
          console.log(e)
        })
      })
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        dd.biz.navigation.close({
          onSuccess: function (result) {},
          onFail: function (err) {}
        })
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {},
          onFail: function () {}
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          let form = {
            id: _this.inputForm.id,
            flowType: _this.inputForm.isLastTask ? 4 : 2,
            formKey: _this.formKey,
            flowTable: _this.flowTable
          }
          _this.$flow.startFlow(form, '/funds/fundsAccountOpenInfo/startFlow');
          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          let form = {
            id: _this.inputForm.id,
            flowType: 3,
            formKey: _this.formKey,
            flowTable: _this.flowTable
          }
          _this.$flow.startFlow(form, '/funds/fundsAccountOpenInfo/startFlow');
          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
  }
}
</script>

<style scoped>
</style>
